import { Product } from "../../models/product";

export enum Direction {
    DESCENDING,
    ASCENDING
}

export enum By {
    DEFAULT,
    NAME,
    PRICE_INC_VAT,
}

export class Sorting {
    direction;
    by = By.DEFAULT;

    constructor(by: By, dir: Direction) {
        this.by = by;
        this.direction = dir;
    }

    /**
     * Returns a string value of this object.
     */
    toValue(): string {
        var x = `${this.by}^${this.direction}`;
        return x;
    }

    static fromValue(s: string): Sorting {
        var x = s.split("^");
        return new Sorting(parseInt(x[0]), parseInt(x[1]));
    }
}


// WEBPACK FOOTER //
// ./src/providers/sorting/sorting.ts